"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDaysToTimestamp = exports.getMaximumValidityDate = exports.getMinimumDeliveryDate = exports.getNextThursday = void 0;
var date_fns_1 = require("date-fns");
var getNextThursday = function () {
    var today = (0, date_fns_1.startOfToday)();
    var dayINeed = 4;
    var currentDay = (0, date_fns_1.getDay)(today);
    if (currentDay <= dayINeed)
        return (0, date_fns_1.setDay)(today, dayINeed);
    return (0, date_fns_1.setDay)((0, date_fns_1.addWeeks)(today, 1), dayINeed);
};
exports.getNextThursday = getNextThursday;
var getMinimumDeliveryDate = function (gdd) {
    var _a;
    if (!((_a = gdd === null || gdd === void 0 ? void 0 : gdd.currentWeekTheoricalTimeSlot) === null || _a === void 0 ? void 0 : _a.date))
        return null;
    var TDate = (0, date_fns_1.fromUnixTime)(gdd.currentWeekTheoricalTimeSlot.date);
    var daysUntilSaturday = (5 - (0, date_fns_1.getDay)(TDate));
    return (0, date_fns_1.addDays)(TDate, daysUntilSaturday);
};
exports.getMinimumDeliveryDate = getMinimumDeliveryDate;
var getMaximumValidityDate = function (deliveryDate) {
    var startOfYearDate = (0, date_fns_1.startOfYear)(new Date(deliveryDate.year, 0, 1));
    var startOfWeekDate = (0, date_fns_1.startOfWeek)(startOfYearDate);
    return (0, date_fns_1.addDays)(startOfWeekDate, (deliveryDate.week - 1) * 7 + 1);
};
exports.getMaximumValidityDate = getMaximumValidityDate;
var addDaysToTimestamp = function (timestamp, days) {
    var date = (0, date_fns_1.fromUnixTime)(timestamp);
    var newDate = (0, date_fns_1.addDays)(date, days);
    return (0, date_fns_1.getUnixTime)(newDate);
};
exports.addDaysToTimestamp = addDaysToTimestamp;
exports.default = { getNextThursday: exports.getNextThursday, getMinimumDeliveryDate: exports.getMinimumDeliveryDate, getMaximumValidityDate: exports.getMaximumValidityDate, addDaysToTimestamp: exports.addDaysToTimestamp };
//# sourceMappingURL=DateCalculation.js.map